module.exports = __webpack_public_path__ + "static/media/dash-moodboard-icon.56f57057.svg";